import { getAuthor, authorUrl } from '../../lib/blog/authors';
import { ogImageUrl, type BlogFrontmatter } from '../../lib/blog/meta';

export function articleHead(fm: BlogFrontmatter, url: string) {
  const image = ogImageUrl(fm.ogImage);
  const author = getAuthor(fm.author);
  return {
    meta: [
      { title: fm.title },
      { name: 'description', content: fm.description },
      { property: 'og:type', content: 'article' },
      { property: 'og:title', content: fm.title },
      { property: 'og:description', content: fm.description },
      { property: 'og:url', content: url },
      { property: 'og:image', content: image },
      { property: 'article:published_time', content: fm.date },
      { property: 'article:modified_time', content: fm.dateModified ?? fm.date },
      ...(author ? [{ property: 'article:author', content: authorUrl(author.slug) }] : []),
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: fm.title },
      { name: 'twitter:description', content: fm.description },
      { name: 'twitter:image', content: image },
    ],
    links: [{ rel: 'canonical', href: url }],
  };
}
